import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserDAO } from '../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { AuthService } from '../../core/services/auth.service';

@Injectable()
@Component({
  selector: 'anchor-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit, OnDestroy {
  userAuthenticatedSubscription: Subscription;
  user: any = {};

  public formVisible: boolean = false;
  public fullView: boolean = true;
  private mediaSubscription: Subscription;

  constructor(
    private media: MediaObserver,
    private router: Router,
    private authenticationService: AuthService,
    private userDAO: UserDAO,
  ) {
    this.mediaSubscription = media
      .asObservable()
      .subscribe((change: MediaChange[]) => {
        change[0].mqAlias == 'xs' || change[0].mqAlias == 'sm'
          ? (this.fullView = false)
          : (this.fullView = true);
      });
  }

  ngOnInit() {}

  onEnrollmentFailed() {
    console.log('enrollment failed');
  }

  public enroll(userForm: any) {
    this.user = userForm.user;
    this.user.status = 'active';
    this.user.username = this.user.email;
    console.log(this.user);
    this.userDAO
      .createEmailAccountForNewCustomer(this.user, userForm.turnstileToken)
      .subscribe(
        (data: User) => {
          data.password = this.user.password;
          this.onEnrolled(data);
        },
        () => {
          this.onEnrollmentFailed();
        },
      );
  }

  onEnrolled(enrolledUser: any) {
    console.log(enrolledUser);
    const username = enrolledUser.username;
    const password = enrolledUser.password;
    this.userAuthenticatedSubscription = this.authenticationService
      .login(username, password)
      .subscribe((userIsAuthenticated: boolean) => {
        if (userIsAuthenticated) {
          this.router.navigate(['sign-up/anchor-code']);
        }
      });
  }

  ngOnDestroy(): void {
    this.mediaSubscription.unsubscribe();
    if (this.userAuthenticatedSubscription) {
      this.userAuthenticatedSubscription.unsubscribe();
    }
  }
}
